import logoSrc from '../../../public/logo.png';
import { ReactComponent as MaintenanceSvg } from 'assets/svg/maintenance.svg';
import { useTranslation } from 'react-i18next';

export default function Maintenance() {
  const { t } = useTranslation('common');
  return (
    <div className="flex h-screen flex-1 flex-col items-center justify-center gap-20 bg-primary-0">
      <img src={logoSrc} alt="VetAmerikan Logo" className="w-4/5 max-w-xs lg:w-[75%] lg:max-w-xs" />
      <div className="flex flex-col items-center justify-center gap-10">
        <MaintenanceSvg />
        <div className="text-2xl font-medium text-secondary">{t('maintenance-text')}</div>
      </div>
    </div>
  );
}

